import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventTicketType } from '../../models/event-ticket-type.interface';
import { isTicketAddable } from '../../models/ticket-status.util';
import { FormsModule } from '@angular/forms';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'hypenation-tickets-ticket-selection',
  standalone: true,
  imports: [CommonModule, FormsModule, NzTagModule],
  templateUrl: './ticket-selection.component.html',
  styleUrl: './ticket-selection.component.css',
})
export class TicketSelectionComponent {
  @Input() ticketTypes: EventTicketType[] = [];
  @Input() selectedTicket: EventTicketType | null | undefined;
  @Input() eventStatus: 'OPEN' | 'CLOSED' | 'PASSED' | 'POSTPONED' | undefined =
    undefined;

  @Output() ticketChange = new EventEmitter<EventTicketType>();

  onTicketChange(ticketType: EventTicketType) {
    if (!isTicketAddable(ticketType, this.eventStatus)) {
      return;
    }
    this.selectedTicket = ticketType;
    this.ticketChange.emit(ticketType);
  }

  isTicketAddable(ticket: EventTicketType): boolean {
    return isTicketAddable(ticket, this.eventStatus);
  }

  isSelected(ticket: EventTicketType): boolean {
    return !!this.selectedTicket && this.selectedTicket.uid === ticket.uid;
  }

  getTicketStatusBadge(
    ticket: EventTicketType
  ): { text: string; color: string } | null {
    // Priority 1: Sold Out
    if (ticket.status === 'SOLD_OUT' || ticket.availableTickets === 0) {
      return { text: 'Sold Out', color: '#7A0012' };
    }

    // Priority 2: Event is PASSED
    if (this.eventStatus === 'PASSED') {
      return { text: 'Passed', color: '#FF5F15' };
    }

    // Priority 3: Ticket is CLOSED or event is CLOSED/POSTPONED
    if (
      ticket.status === 'CLOSED' ||
      this.eventStatus === 'CLOSED' ||
      this.eventStatus === 'POSTPONED'
    ) {
      return { text: 'Closed', color: '#FF5F15' };
    }

    // Priority 4: Open (ticket is OPEN, event is OPEN, and tickets available)
    if (isTicketAddable(ticket, this.eventStatus)) {
      return { text: 'Open', color: '#4bb543' };
    }

    // Default: Closed if we can't determine
    return { text: 'Closed', color: '#FF5F15' };
  }
}
